import React from "react";
import { Chip } from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  AccessTime as AccessTimeIcon,
} from "@mui/icons-material";

const StopStatusChip = ({ status }) => {
  const configs = {
    pending: {
      color: "default",
      label: "Pending",
      icon: <AccessTimeIcon fontSize="small" />,
    },
    completed: {
      color: "success",
      label: "Completed",
      icon: <CheckCircleIcon fontSize="small" />,
    },
  };

  const config = configs[status] || configs.pending;

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      size="small"
      color={config.color}
      variant="outlined"
    />
  );
};

export default StopStatusChip;
